import useCompetitionCategoryMultiSelect from './UseCompetitionCategoryMultiSelect';

import MultiSelect from '../MultiSelect';

import global from '../../GlobalStyle.module.css';

const CompetitionCategoryMultiSelect = ({ label, name, value, error, message, onChange, showMixed=true }) => {
  const { eventCompetitionGenderState, options } = useCompetitionCategoryMultiSelect(showMixed);

  return eventCompetitionGenderState.message
    ? <span className={global.LoadingMsg}>{eventCompetitionGenderState.message}</span>
    : (
      <MultiSelect
        label={label}
        name={name}
        value={value}
        options={options}
        error={error}
        message={message}
        isLoading={eventCompetitionGenderState.isLoading}
        onChange={onChange} />
    );
};

export default CompetitionCategoryMultiSelect;